import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { getAppId, getApplicantBirthDate, getEmail, getStageID, getTravelInfo, set1BpersonalInfo, setAddressInfo, setParentInfo, setTStageID } from "../utility/Common";
import Header from "./layout/Header";
import NavBar_appID from "./layout/NavBar_appID";
import Footer from "./layout/Footer";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { createNotification } from "./Popup";
import { applicationManagementMasilingi } from "../utility/services/apiService";
import { messages } from "../utility/services/message";
import { getResource } from "../utility/services/resources";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import CentryReusableComponent from "./CentryReusableComponent";
import { travelInfo } from "../formValidation/FormValidator";

function HabariZaSafari() {
  let navigate = useNavigate();

  const birthDate = getApplicantBirthDate();
  let bellowAge;
  if (birthDate) {
    const birthYear = birthDate.split(" ")[3];
    if (birthYear) {
      bellowAge = new Date().getFullYear() - birthYear;
    }
  }

  const travelInfoData = useLocation();
  // var Stage = travelInfoData.state?.DocStageID;
  var Stage = +getStageID()

  const [ZanzibarID, setZanzibarID] = useState("");
  const [BirthWardID, setBirthWardID] = useState("");
  const [AnyOtherID, setAnyOtherID] = useState("");
  const [BirthVillage, setBirthVillage] = useState("");

  const [TravelPurposeID, setTravelPurposeID] = useState("");
  const [VisitCountryID, setVisitCountryID] = useState("");
  const [GuardianFullName, setGuardianFullName] = useState("");
  const [GuardianJob, setGuardianJob] = useState("");
  const [GuardianBox, setGuardianBox] = useState("");
  const [GuardianPhoneNumber, setGuardianPhoneNumber] = useState("");
  const [GuardianRelationShip, setGuardianRelationShip] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [visitPurpose, setVistiPurpos] = useState([]);
  const [OccupationID, setOccupationID] = useState("");
  const [ocupations, setOcupations] = useState([]);
  const [errors, setErrors] = useState({});
  const [FatherFullName, setFatherFullName] = useState("");
  const [MotherFullName, setMotherFullName] = useState("");
  const [FatherDOB, setFatherDOB] = useState("");
  const [MotherDOB, setMotherDOB] = useState("");
  const [FatherDistrictID, setFatherDistrictID] = useState("");
  const [MotherDistrictID, setMotherDistrictID] = useState("");
  const [FatherWard, setFatherBirthWardID] = useState([]);
  const [MotherWard, setMotherBirthWardID] = useState([]);
  const [FatherVillage, setFatherVillage] = useState("");
  const [MotherVillage, setMotherVillage] = useState("");
  const { checkApplicationStage } = CentryReusableComponent({});
  const [stageID, setStageID] = useState(null);
  const [phoneError, setPhoneError] = useState("");

  //======Lookups
  useEffect(() => {
    fetchPurpos();
    setTravelInfo();
  }, []);

  const setTravelInfo = () => {
    checkApplicationStage(2)
    const data = getTravelInfo()
    setStageID(+data?.DocStageID);
    setTravelPurposeID(+data?.TravellingPurpose);
    setVisitCountryID(+data?.CountryID);
    setCountries(data?.CountryName);
    setVistiPurpos(data?.PurposeOfTravel);
    setVistiPurpos(Array.isArray(data?.PurposeOfTravel) ? data?.PurposeOfTravel : []);
    setCountries(Array.isArray(data?.CountryName) ? data?.CountryName : []);
    setOcupations(Array.isArray(data?.Occupation) ? data?.Occupation : []);
    setOcupations(data?.Occupation);
    setOccupationID(+data?.OccupationID);
    setGuardianFullName(data?.GuardianFullName);
    setGuardianJob(data?.GuardianJob);
    setGuardianBox(data?.GuardianBox);
    setGuardianPhoneNumber(data?.GuardianPhoneNumber);
    setGuardianRelationShip(data?.GuardianRelationShip);
  };


  const fetchCountries = async () => {
    const result = await getResource("VisitName", getAppId(), "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setCountries(result);
      fetchOcupations();
    } else {
      setCountries([]);
    }
  };

  const fetchPurpos = async () => {
    const result = await getResource("Purpose", "null", "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setVistiPurpos(result);
      fetchCountries();
    } else {
      setVistiPurpos([]);
    }
  };

  const fetchOcupations = async () => {
    const result = await getResource("Occupation", "null", "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setOcupations(result);
    } else {
      setOcupations([]);
    }
  };


  const validatePhoneNumber = (phoneNumber) => {
    const parsedNumber = parsePhoneNumberFromString(`+${phoneNumber}`, "TZ");
    if (!parsedNumber || !parsedNumber.isValid()) {
      return "Simu ya mkononi si sahihi.";
    }
    return "";
  };
  const handlePhoneNumberChange = (phoneNumber) => {
    setGuardianPhoneNumber(phoneNumber);
    const error = validatePhoneNumber(phoneNumber);
    setPhoneError(error);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (phoneError) {
      createNotification({ type: "error", message: phoneError })();
      return;
    }

    const formData = {
      ApplicationId: getAppId(),
      TravellingPurposeID: +TravelPurposeID,
      CountryID: +VisitCountryID,
      OccupationID: +OccupationID,
      EmailAddress: getEmail(),
      Action: Stage == 240 ? "Insert" : "Update",
      GuardianFullName,
      GuardianJob,
      GuardianBox,
      GuardianPhoneNumber,
      GuardianPhoneNumber: "",
      GuardianRelationShip,
    };

    const newErrors = travelInfo(formData);
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});
      setIsloading(true);

      const navigateToStage = (stage, message) => {
        const routes = {
          240: "/stp4",
          250: "/stp5",
          260: "/stp6",
          270: "/stp7",
        };
        navigate(routes[stage] || "/continue");
        // createNotification({ type: "success", message })();
      };
      applicationManagementMasilingi(formData, "add-travel-info")
        .then((result) => {
          setIsloading(false);
          if (result.code == 1) {
            if (result.data) {
              const stID = result?.data[0]?.StageID
              setTStageID(stID)
            }
            if (Stage == 240 && formData.Action == "Insert") {
              navigate("/stp5");
            } else if (Stage == 250 && formData.Action == "Update") {
              navigate("/stp5");
            } else {
              navigateToStage(Stage, result.message);
            }
            setStageID(result?.data[0]?.StageID);
            createNotification({ type: "success", message: result.message })();
          } else if (
            result.code == 3 ||
            result.message.toLowerCase().includes("expire")
          ) {
            createNotification({ type: "error", message: "Session expired" })();
            navigate("/");
          } else {
            createNotification({ type: "error", message: result.message })();
          }
        })
        .catch(() => {
          setIsloading(false);
          createNotification({ type: "error", message: messages.networkError })();
        });
    };
  }

  const endeleaBadae = () => {
    navigate("/");
  };

  //--------------------BackStage
  const handleBackStep = (endpoint, formData, routes) => {
    try {
      applicationManagementMasilingi(formData, endpoint).then((result) => {
        if (
          result.code == 3 ||
          result.message?.toLowerCase().includes("expire")
        ) {
          createNotification({ type: "error", message: "Session expired" })();
          navigate("/");
        } else if (result.code == 1 && result.data.length > 0) {
          if (endpoint == "add_missing_personal_info") {
            set1BpersonalInfo(result?.data[0])
          } else if (endpoint == "add-address-info") {
            setAddressInfo(result.data[0])
          } else if (endpoint == "add-parents-info") {
            setParentInfo(result.data[0])
          }
          const applicationFrom = result?.data[0]?.ApplicationFrom;
          const navigatePath = routes[applicationFrom] || routes.default;
          if (navigatePath) {
            navigate(navigatePath, { state: result?.data[0] });
          } else {
            const info = { type: "error", message: result.message };
            createNotification(info)();
          }
        } else {
          const info = { type: "error", message: result.message };
          createNotification(info)();
        }
      });
    } catch (error) {
      const info = { type: "error", message: messages.networkError };
      createNotification(info)();
    }
  };

  const backStp1 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      BirthVillage,
      BirthWardID,
      ZanzibarID,
      AnyOtherID,
    };

    const routes = {
      3: "/stp1B",
      4: "/stp1",
      5: "/stp1",
      default: null,
    };

    handleBackStep("add_missing_personal_info", formData, routes);
  };

  const backStp2 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      HouseNumber: "",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
    };

    const routes = {
      default: "/stp2",
    };

    handleBackStep("add-address-info", formData, routes);
  };

  const backStp3 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
      HouseNumber: "",
      FatherFullName,
      FatherDOB,
      FatherDistrictID,
      FatherWard,
      FatherVillage,
      MotherFullName,
      MotherDOB,
      MotherDistrictID,
      MotherWard,
      MotherVillage,
    };

    const routes = {
      default: "/stp3",
    };

    handleBackStep("add-parents-info", formData, routes);
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp1();
                    }}
                    className="list-group-item done"
                  >
                    Habari Binafsi{" "}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp2();
                    }}
                    className="list-group-item done"
                  >
                    Anuwani ya Makazi
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp3();
                    }}
                    className="list-group-item done"
                  >
                    Habari za Wazazi{" "}
                  </Link>
                  <Link to="#" className="list-group-item active">
                    Habari za Safari
                  </Link>
                  <Link className="list-group-item ">Wakati wa Dharura</Link>
                  <Link className="list-group-item ">Viambatanisho </Link>
                  <Link className="list-group-item ">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Malipo </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-four-form" onSubmit={handleSubmit}>
                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">Madhumuni ya Safari</h3>
                      </div>
                      <div className="box-body" style={{ display: "block" }}>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Dhumuni la Safari
                              </label>

                              <select
                                id="TravelPurposeID"
                                className="form-control"
                                name="TravelPurposeID"
                                onChange={(e) =>
                                  setTravelPurposeID(e.target.value)
                                }
                                value={TravelPurposeID}
                                required
                              >
                                <option value="">
                                  Chagua Dhumuni la Safari
                                </option>
                                {Array.isArray(visitPurpose) &&
                                  visitPurpose.length > 0 ? (
                                  visitPurpose.map((purpose) => (
                                    <option
                                      key={purpose.id}
                                      value={purpose.ResourceID}
                                    >
                                      {purpose.ResourceName}
                                    </option>
                                  ))
                                ) : (
                                  <option value="" disabled>
                                    No purposes available
                                  </option>
                                )}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Nchi Unayokwenda
                              </label>

                              <select
                                id="VisitCountryID"
                                className="form-control"
                                name="VisitCountryID"
                                onChange={(e) =>
                                  setVisitCountryID(e.target.value)
                                }
                                value={VisitCountryID}
                                required
                              >
                                <option value="">Chagua Nchi</option>
                                {Array.isArray(countries) &&
                                  countries.length > 0 ? (
                                  countries.map((country) => (
                                    <option
                                      key={country.id}
                                      value={country.ResourceID}
                                    >
                                      {country.ResourceName}
                                    </option>
                                  ))
                                ) : (
                                  <option value="" disabled>
                                    No countries available
                                  </option>
                                )}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Kazi Yako</label>
                              <select
                                id="OccupationID"
                                className="form-control"
                                name="OccupationID"
                                onChange={(e) =>
                                  setOccupationID(e.target.value)
                                }
                                value={OccupationID}
                                required
                              >
                                <option value="">Chagua Kazi</option>
                                {Array.isArray(ocupations) &&
                                  ocupations.length > 0 ? (
                                  ocupations.map((occupation) => (
                                    <option
                                      key={occupation.id}
                                      value={occupation.ResourceID}
                                    >
                                      {occupation.ResourceName}
                                    </option>
                                  ))
                                ) : (
                                  <option value="" disabled>
                                    No occupations available
                                  </option>
                                )}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ====================Gurdian================== */}
                    <div>
                      {bellowAge == undefined || bellowAge == null || bellowAge >= 18 ? (
                        <p></p>
                      ) : (
                        <div className="box box-default">
                          <div className="box-header with-border">
                            <p style={{ fontSize: "100%" }}>
                              Waombaji waliochini ya <b>miaka 18</b> maombi yao lazima
                              yaidhinishwe na Mzazi/Mlezi
                            </p>
                          </div>
                          <div
                            className="box-body"
                            style={{ display: "block" }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group required">
                                  <label className="control-label">
                                    Jina kamili
                                  </label>
                                  <input
                                    type="text"
                                    id="GuardianFullName"
                                    className="form-control"
                                    name="GuardianFullName"
                                    onChange={(e) => {
                                      const regex = /^[a-zA-Z '-]*$/;
                                      const value = e.target.value.toUpperCase();
                                      if (regex.test(value) || value === '') {
                                        setGuardianFullName(value);
                                      }
                                    }}
                                    value={GuardianFullName}
                                    required
                                  />
                                  <p className="help-block help-block-error"></p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group required">
                                  <label className="control-label">Kazi</label>
                                  <input
                                    type="text"
                                    id="GuardianJob"
                                    className="form-control"
                                    name="GuardianJob"
                                    onChange={(e) => {
                                      const regex = /^[a-zA-Z ]*$/;
                                      const value = e.target.value.toUpperCase();
                                      if (regex.test(value) || value === '') {
                                        setGuardianJob(value);
                                      }
                                    }}
                                    value={GuardianJob}
                                    required
                                  />
                                  <p className="help-block help-block-error"></p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group required">
                                  <label className="control-label">
                                    Anuani
                                  </label>
                                  <input
                                    type="text"
                                    id="GuardianBox"
                                    className="form-control"
                                    name="GuardianBox"
                                    onChange={(e) => {
                                      const regex = /^[a-zA-Z0-9 ,-]*$/;
                                      const value = e.target.value.toUpperCase();
                                      if (regex.test(value) || value === '') {
                                        setGuardianBox(value);
                                      }
                                    }}
                                    value={GuardianBox}
                                    required
                                  />
                                  <p className="help-block help-block-error"></p>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group required">
                                  <label className="control-label">
                                    Simu ya Mkononi
                                  </label>
                                  <PhoneInput
                                    country={"tz"}
                                    enableSearch={true}
                                    id="GuardianPhoneNumber"
                                    name="GuardianPhoneNumber"
                                    inputStyle={{
                                      width: "100%",
                                      borderRadius: ".2rem",
                                    }}
                                    onChange={handlePhoneNumberChange}
                                    value={GuardianPhoneNumber}
                                    required
                                  />
                                  {phoneError && (
                                    <p className="help-block help-block-error text-danger">
                                      {phoneError}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group required">
                                  <label className="control-label">
                                    Uhusiano
                                  </label>
                                  <input
                                    type="text"
                                    id="GuardianRelationShip"
                                    className="form-control"
                                    name="GuardianRelationShip"
                                    onChange={(e) => {
                                      const regex = /^[a-zA-Z ]*$/;
                                      const value = e.target.value.toUpperCase();
                                      if (regex.test(value) || value === '') {
                                        setGuardianRelationShip(value);
                                      }
                                    }}
                                    value={GuardianRelationShip}
                                    required
                                  />
                                  <p className="help-block help-block-error"></p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {errors && (
                        <div className="help-block help-block-error">
                          {Object.values(errors).map((error, index) => (
                            <p className="help-block help-block-error" key={index}>{error}</p>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* ====================================== */}
                    <div className="box-footer">
                      <div className="row">
                        <div className="col-md-4">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              backStp3();
                            }}
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveBack"
                          >
                            <i className="fa fa-angle-double-left"></i> | Hatua
                            Iliyotangulia
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <Link
                            className="btn btn-labeled btn-block btn-default"
                            name="SaveExit"
                            onClick={(e) => {
                              e.preventDefault();
                              endeleaBadae();
                            }}
                          >
                            Hifadhi na Toka | <i className="fa fa-save"></i>{" "}
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <button
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveNext"
                          >
                            {isloading ? "Subiri.." : "Hifadhi na Endelea |"} {" "}
                            <i className="fa fa-angle-double-right"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default HabariZaSafari;
